import colors from "shared/styles/colors";
import { ThemeType } from "shared/styles/theme";
import styled, { css, StyledConfig } from "styled-components";
import theme from "styled-theming";

export enum FormGroupVariant {
    primary = "primary",
    error = "error"
}

const formGroupInputBorderColor = theme.variants("mode", "variant", {
    [FormGroupVariant.primary]: {
        [ThemeType.light]: colors.grey_2,
        [ThemeType.dark]: colors.grey_2
    },
    [FormGroupVariant.error]: {
        [ThemeType.light]: colors.warningDark,
        [ThemeType.dark]: colors.warningDark
    }
});

const formGroupExtensionBorderColor = theme("mode", {
    [ThemeType.light]: colors.grey_2,
    [ThemeType.dark]: colors.grey_2
})

export const Label = styled.label`
    font-family: "Gilroy-Medium", "medium-fallback";
    font-size: var(--header-4-font-size);
    display: inline-block;
    margin-bottom: 5px;
`

const labelValueColor = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.white
})

export const LabelWithIndentedValue = styled.div`
    margin-bottom: 18px;
    font-size: var(--header-4-font-size);
    .value {
        margin-left: 20px;
        font-weight: 400;
        color: ${labelValueColor}
    }
    a {
        color: inherit;
        border-bottom: solid 0.7px ${colors.purplePrimary};
        margin-bottom: 5px;
    }

`;

const formGroupWarningColor = theme("mode", {
    [ThemeType.light]: colors.warningDark,
    [ThemeType.dark]: colors.warningSecondary
})

export const FormGroup = styled.div<IFormGroupProps>`
    ${props => !props.$noMargin && css`
        margin-bottom: 24px;
    `}
    input, .react-select__control {
        border: 2px solid ${formGroupInputBorderColor};
    }
    ${props => props.$inline && css`
        display: inline-flex;
        width: 100%;
        align-items: baseline;
        ${!props.$gap && 'justify-content: space-between;'}
    `}
    .error {
        color: ${formGroupWarningColor};
    }
    .warning {
        color: ${colors.orangeDark};
    }
    ${props => props.$gap && css`
        gap: ${props.$gap}px;
`}
`

const FormGroupExtensionBase = css`
    border: 2px solid ${formGroupExtensionBorderColor};
    display: inline-flex;
`

export const FormGroupExtension = styled.div<IFormGroupExtensionProps>`
    font-size: var(--header-4-font-size);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    min-height: 40px;
    ${FormGroupExtensionBase};
    ${props => props.first && css`
        border-radius: 25px 0px 0px 25px;
    `}
    ${props => props.last && css`
        border-radius: 0px 25px 25px 0px;
    `}
`

interface IFormGroupExtensionProps {
    first?: boolean;
    last?: boolean;
}

interface IFormGroupProps {
    variant?: FormGroupVariant;
    $noMargin?: boolean;
    $inline?: boolean;
    $gap?: number;
}

FormGroup.defaultProps = {
    variant: FormGroupVariant.primary
}